// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2557I","importantInfo":"styles_importantInfo__1IPZV"};